export const siteKeys = {
  all: ['sites'] as const,
  lists: () => [...siteKeys.all, 'list'] as const,
  list: (orgId?: string) => [...siteKeys.lists(), orgId ?? 'all'] as const,
  details: () => [...siteKeys.all, 'detail'] as const,
  detail: (id: string) => [...siteKeys.details(), id] as const,
  interventionCount: (id: string) =>
    [...siteKeys.all, 'interventionCount', id] as const,
}
